/**
 * What a service's catch block may read off the value it caught (SCRUM-1904, slice 1 of
 * SCRUM-1395). The caught value is `unknown` once `useUnknownInCatchVariables` is on; the services
 * read it through these two helpers so the checker knows the shape they expect, and nothing
 * changes at runtime: `asCaught` returns its argument as-is (no coercion, so a thrown string or a
 * null fails exactly where it always did), and `errorPayload` is the exact expression the services
 * wrote inline before.
 *
 * `response` is optional: a request that never got an answer (network down, backend
 * restarting) rejects with an axios error that has no `response`. Until SCRUM-2001 the type
 * declared it present, and two catches in sitesSlice read `err.response.data` unguarded — a
 * TypeError inside the catch, so the failure never reached the notification hub.
 */
export type CaughtError = { message?: string; response?: { status?: number; data?: any } };

export const asCaught = (err: unknown): CaughtError => err as CaughtError;

/** The redux error payload: the server's response body, or `{ message }` when there is none. */
export const errorPayload = (err: unknown) =>
  asCaught(err)?.response?.data ?? { message: asCaught(err)?.message };
